var map = {
	"./ebanisteria.jpg": 1902,
	"./electricos.jpg": 2788,
	"./estudiantil.jpg": 2869,
	"./gas.jpg": 7373,
	"./griferia.jpg": 6407,
	"./tornilleria.jpg": 8828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2571;